<div class="upload">
  <div>
    <ul>
      <li data-test="file-document-component" class="file lib-elevation-1" *ngFor="let file of files" [title]="file.fileName">
        <button type="button" [class]="file.invalid ? 'lib-button-warn' : 'lib-button'" (click)="viewFile(file)">
          <lib-icon name="document"></lib-icon>
          <span>{{file.fileName}}
            <i class="lib-legend">{{(file.createdAt | date) || null}}</i>
          </span>
        </button>
        <button type="button" class="lib-button" (click)="downloadFile(file)">
          <lib-icon class="icon-180" name="share"></lib-icon>
        </button>
        <button hidden type="button" class="lib-button options">
          <lib-icon name="options"></lib-icon>
        </button>
        <ul class="lib-elevation-1">
          <!-- <li>
            <button type="button" class="lib-button" (click)="renameFile(file)">
              <lib-icon name="edit"></lib-icon>
              <span>Rename</span>
            </button>
          </li> -->
          <li>
            <button type="button" class="lib-button" (click)="openEditFile(file, $event)">
              <lib-icon name="edit"></lib-icon>
              <span>Edit
                <!-- <i class="lib-legend">{{(file.createdAt | date) || null}}</i> -->
              </span>
            </button>
          </li>
          <li [ngSwitch]="!!file?.invalid">
            <button *ngSwitchCase="true" type="button" class="lib-button-primary" (click)="toggleValidation(file)">
              <lib-icon name="done"></lib-icon>
              <span>Validate</span>
            </button>
            <button *ngSwitchCase="false" type="button" class="lib-button-warn" (click)="toggleValidation(file)">
              <lib-icon name="minus"></lib-icon>
              <span>Invalidate</span>
            </button>
          </li>
          <li>
            <button type="button" class="lib-button-warn" (click)="deleteFile(file)">
              <lib-icon name="close"></lib-icon>
              <span>Delete</span>
            </button>
          </li>
        </ul>
      </li>
      <li>
        <lib-upload theme="flat-link" [target]="uploadTarget" [application]="application" [type]="path" [userId]="userId"
          (success)="onSuccessUpload($event)"></lib-upload>
      </li>
    </ul>
  </div>
</div>

<a style="display:none;" #hiddenUrl href="" target="_blank"></a>

<ng-template #editRef>
  <form class="modal-form edit-form" [formGroup]="editForm" (ngSubmit)="submitEditFile($event)">
    <lib-input formControlName="path" hidden></lib-input>
    <lib-input formControlName="key" hidden></lib-input>
    <div>
      <div>
        <p class="lib-legend">Name</p>
        <lib-input formControlName="fileName" type="text"></lib-input>
      </div>
      <span class="lib-spacer-fixed"></span>
      <span class="lib-spacer-fixed"></span>
      <div>
        <p class="lib-legend">Created</p>
        <lib-input formControlName="createdAt" type="date"></lib-input>
      </div>
    </div>
    <nav class="lib-nav">
      <span class="lib-spacer"></span>
      <button type="submit" class="lib-button-flat-primary" [disabled]="editForm.invalid">
        <span>Update</span>
      </button>
    </nav>
  </form>
</ng-template>
